/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DatabaseImageHeaderBlockType = {
    Icon: 'ICON',
    Image: 'IMAGE'
} as const;
export type DatabaseImageHeaderBlockType = typeof DatabaseImageHeaderBlockType[keyof typeof DatabaseImageHeaderBlockType];


export function DatabaseImageHeaderBlockTypeFromJSON(json: any): DatabaseImageHeaderBlockType {
    return DatabaseImageHeaderBlockTypeFromJSONTyped(json, false);
}

export function DatabaseImageHeaderBlockTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseImageHeaderBlockType {
    return json as DatabaseImageHeaderBlockType;
}

export function DatabaseImageHeaderBlockTypeToJSON(value?: DatabaseImageHeaderBlockType | null): any {
    return value as any;
}

